import { ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TooltipService } from './tooltip.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, OnDestroy {
  text: string;
  show: boolean = false;
  elementRef: HTMLElement;
  toggleSub: Subscription;

  constructor(private ts: TooltipService) { }

  ngOnInit() {
    this.toggleSub = this.ts.tooltipToggle.subscribe((s: boolean) => {
      if(s) {
        this.toggle();
      } else {
        this.text = null;
        this.show = s;
      }
    });
  }

  ngOnDestroy(): void {
    this.toggleSub.unsubscribe();
  }

  private toggle() {
    this.text = this.ts.text;
    setTimeout(() => {
      this.elementRef = this.ts.elementRef;
      this.show = this.ts.show;
    }, 200);
  }

}
